module.exports = __webpack_public_path__ + "img/background-panel-hello--dark.ed28147a.svg";